module.exports = __webpack_public_path__ + "static/footer_logo-c324242f1d2a30c25a5071c963b38b9d.svg";